/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
// import SecureLS from "secure-ls";
import _ from "lodash";
import SecureLS from "@/utils/secure-ls";
var ls = new SecureLS({ isCompression: false, UseSessionStorage: true });

Vue.use(Vuex);
import moduleUser from "./user/moduleUser.js";
import moduleAuth from "./auth";
import moduleAdmin from "./admin";
import moduleChannel from "./channel";
import modulePosts from "./posts";
import moduleBrand from "./brand";
import moduleDesign from "./design";
import student from "./student";
import achievement from "./achievement";
import newsletter from "./newsletter";
import email from "./email";
import moduleELearning from "./elearning";
import author from "./author";
import topic from "./topic";
import cart from "./cart";
import wishlist from "./wishlist";
import placeOrder from "./placeOrder";
import learningTracker from "./learningTracker";
import UI from "./UI";
import cms from "../views/social/admin/pages/blog/store";
import cmstag from "../views/social/admin/pages/add-tags/store";
import corporate from "./corporate";
import companydash from "./companydash";
import services from "./services";
import respitecare from "./respitecare";
import coach from "./coach";
import google from "./google";
import linkedin from "./linkedin";
import whatsapp from "./whatsapp";
import mantra from "./mantra";
import subscribe from "./subscribe";
import payment from "./payment";
import transaction from "./transaction";
import pushNotification from "./pushNotification";
import testimonial from "./testimonial";
import karunaPoint from "./karunaPoint";
import hcp from "./hcp";
import cmsAuthor from "./cmsAuthor";
import meditation from "./meditation";
import aboutUs from "./aboutUs";
import affiliate from "./affiliate";
import doctor from "./doctor";
import hoc from "./hoc";
import membership from "./membership";
import ffc from "./ffc";
import homePageBanner from "./homePageBanner";
import playlist from "./playlist";
import mainAboutUs from "./main-about-us";
import homepage from "./homepage";
import wellBeingInitaitive from "./wellBeingInitaitive";
import globalForm from "./globalForm";
import gallery from "./gallery";
import campaignPageBanner from "./campaignPageBanner";
import medicalCancer from "./medicalCancer";
import medicalFaq from "./medicalFaq";
import partners from "./partners";
import friendsUpdates from "./friendsUpdates";
import regulationPolicy from "./regulationPolicy";
import bookMarks from "./bookMark";
import podcast from "./podcast";
import quotes from "./quotes";

let initialStoreModules = {
  auth: moduleAuth,
  brand: moduleBrand,
  user: moduleUser,
  design: moduleDesign,
  channel: moduleChannel,
  posts: modulePosts,
  admin: moduleAdmin,
  student,
  achievement,
  newsletter,
  email,
  eLearning: moduleELearning,
  author,
  topic,
  cart,
  wishlist,
  placeOrder,
  learningTracker,
  UI,
  cms,
  cmstag,
  corporate,
  companydash,
  services,
  respitecare,
  coach,
  google,
  linkedin,
  whatsapp,
  mantra,
  subscribe,
  transaction,
  payment,
  pushNotification,
  testimonial,
  karunaPoint,
  hcp,
  cmsAuthor,
  meditation,
  aboutUs,
  affiliate,
  doctor,
  hoc,
  membership,
  ffc,
  homePageBanner,
  playlist,
  mainAboutUs,
  homepage,
  wellBeingInitaitive,
  globalForm,
  gallery,
  campaignPageBanner,
  medicalCancer,
  medicalFaq,
  partners,
  friendsUpdates,
  regulationPolicy,
  bookMarks,
  podcast,
  quotes,
};

export default new Vuex.Store({
  modules: initialStoreModules,
  mutations: {
    // reset default state modules by looping around the initialStoreModules
    logout(state) {
      _.forOwn(initialStoreModules, (value, key) => {
        state[key] = _.cloneDeep(value.state);
      });

      // localStorage.removeItem("token");
      // localStorage.removeItem("vuex");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("vuex");
    },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },
  },
  state: {
    windowWidth: 0,
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
window.ls = ls;
export { ls };
